import { Grid } from '@mui/material';
import CustomField from '../../../../components/CustomFormsComponents/CustomField';

interface CamposSvccProps {
    /** Configuración de campos del formulario (la misma que antes se mapeaba entera). */
    config: any[];
    /** Qué campos de la configuración van en este bloque, por `name`. Sin esto, todos. */
    nombres?: string[];
    formData: Record<string, any>;
    errors: Record<string, any>;
    onChange: (name: string, value: any) => void;
    onlyVisual?: boolean;
    /** Contenido extra debajo de un campo (por ejemplo, un checkbox asociado). */
    debajoDe?: (nombre: string) => React.ReactNode;
}

/**
 * Los campos de un bloque del drawer, dibujados igual que antes: `CustomField`
 * con su `gridSpace`, su error y su ayuda. Permite repartir la configuración
 * en secciones sin tocar validaciones ni handlers.
 */
const CamposSvcc = ({
    config,
    nombres,
    formData,
    errors,
    onChange,
    onlyVisual,
    debajoDe
}: CamposSvccProps) => {
    const campos = nombres ? config.filter((campo) => nombres.includes(campo?.name)) : config;

    return (
        <Grid container columnSpacing={1.5} rowSpacing={1.25}>
            {campos.map((campo) => (
                <Grid
                    item
                    key={campo.name}
                    xs={campo?.gridSpace?.xs ?? 12}
                    sm={campo?.gridSpace?.sm}
                    md={campo?.gridSpace?.md}
                    lg={campo?.gridSpace?.lg}
                >
                    <CustomField
                        config={campo}
                        value={formData[campo.name]}
                        onChange={onChange}
                        onlyVisual={onlyVisual}
                        error={errors[campo.name]?.hasError}
                        helperText={errors[campo.name]?.errorMessage || campo.helperText}
                    />
                    {debajoDe?.(campo.name)}
                </Grid>
            ))}
        </Grid>
    );
};

export default CamposSvcc;
